/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Helpers, Report, ReportFile } from 'src/app/model';
import { DocumentType } from 'src/app/model/enums/document.type';
import { FileActionType } from 'src/app/model/enums/file.action.type';
import { PresetValue } from 'src/app/model/preset-value';
import { ReportProvider } from 'src/app/providers';
import { LogService } from 'src/app/services';
@Component({
  selector: 'create-folder-modal',
  templateUrl: './create-folder.modal.html',
  styleUrls: ['./create-folder.modal.scss']
})
export class CreateFolderModal implements OnInit, OnDestroy {
  subject: Subject<ReportFile>;
  subscription: any;
  folderName: string = '';
  path: string;
  report: Report;
  selected: ReportFile = new ReportFile();
  actionType: FileActionType;
  FileActionType = FileActionType;
  DocumentType = DocumentType;

  docTypes: PresetValue[] = Helpers.getDocuments();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private reportProvider: ReportProvider,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onConfirm(): void {
    switch (this.actionType) {
      case FileActionType.CREATE_FOLDER:
        //this.path = this.path + "/" + this.folderName;
        this.reportProvider.createFolder(this.report.ID, this.folderName, this.selected ? this.selected.ID : null)
          .subscribe(data => {
            if (data.success) {
              this.bsModalRef.hide();
              this.subject.next(new ReportFile(data.result));
              this.subject.complete();
            }
          }, err => {
            this.logService.error(err);
          });
        break;
      case FileActionType.RENAME:
        this.reportProvider.renameFileOrFolder(this.report.ID, this.path, this.selected.NAME, this.selected.ID)
          .subscribe(data => {
            if (data.success) {
              this.bsModalRef.hide();
              this.subject.next(new ReportFile(data.result));
              this.subject.complete();
            }
          }, err => {
            this.logService.error(err);
          });
        break;
      case FileActionType.CHANGE_TYPE:
        this.reportProvider.changeDocType(this.report.ID, this.selected.DOCUMENT_TYPE, this.selected.ID)
          .subscribe(data => {
            if (data.success) {
              this.bsModalRef.hide();
              this.subject.next(new ReportFile(data.result));
              this.subject.complete();
            }
          }, err => {
            this.logService.error(err);
          });
          break
      default:
        break;
    }
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  validateInput(): boolean {
    if (!this.folderName || !this.folderName.trim()) {
      return false;
    }

    return true;
  }

  validLength(): boolean {
    if (this.folderName && this.folderName.length > 250) {
      return false;
    }
    return true;
  }

  docTypeChanged(value: any): void {
    this.selected.DOCUMENT_TYPE = value != null ? value.VALUE: null;
  }

}
